import { useRef } from "react";
import { Checkbox } from "../Checkbox/Checkbox";
import "./checkForm.css";

export const CheckForm = ({ children, onClick }) => {
    const checkedRef = useRef(false);

    const toggleCheckbox = () => {
        checkedRef.current = !checkedRef.current;
        onClick(checkedRef.current);
    }

    return (
      <div className="check-form">
        <Checkbox isChecked={checkedRef.current} onClick={toggleCheckbox} />
        <p className="body4" onClick={toggleCheckbox}>
          {children}
        </p>
      </div>
    );
}